import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { accountApi } from "@/lib/api";

const AccountContext = createContext(null);

export const AccountProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    accountApi
      .get("/account/me")
      .then(({ data }) => setCustomer(data))
      .catch(() => setCustomer(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await accountApi.post("/account/login", { email, password });
    setCustomer(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await accountApi.post("/account/register", payload);
    setCustomer(data);
    return data;
  };

  const logout = async () => {
    await accountApi.post("/account/logout");
    setCustomer(false);
  };

  return <AccountContext.Provider value={{ customer, setCustomer, login, register, logout }}>{children}</AccountContext.Provider>;
};

export const useAccount = () => useContext(AccountContext);

export const RequireAccount = ({ children }) => {
  const { customer } = useAccount();
  const location = useLocation();
  if (customer === null) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="account-loading">
        <Loader2 className="h-8 w-8 animate-spin text-acid" />
      </div>
    );
  }
  if (!customer) return <Navigate to={`/account/accedi?next=${encodeURIComponent(location.pathname)}`} replace />;
  return children;
};
